import styles from './FolderItemFolder.module.css';
import React from 'react';
import { Icon } from '@he-novation/design-system/components/graphics/Icon/Icon';
import { colorFolderItemIcon } from '@he-novation/design-system/constants/constants.style';
import cn from 'classnames';

type FolderItemFolderProps = {
    onClick?: React.MouseEventHandler;
    iconColor?: string;
    className?: string;
};

export function FolderItemFolder({ onClick, iconColor, className }: FolderItemFolderProps) {
    return (
        <div onClick={onClick} className={cn(styles.folderItemFolder, className)}>
            <Icon
                icon={{
                    name: 'folder_plain',
                    fill: iconColor || colorFolderItemIcon,
                    stroke: 'none'
                }}
            />
        </div>
    );
}
